import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_CREDENTIAL_LIST_REQUEST = 'FETCH_CREDENTIAL_LIST_REQUEST';
export const FETCH_CREDENTIAL_LIST_SUCCESS = 'FETCH_CREDENTIAL_LIST_SUCCESS';
export const FETCH_CREDENTIAL_LIST_FAILURE = 'FETCH_CREDENTIAL_LIST_FAILURE';

export const CREATE_CREDENTIAL_REQUEST = 'CREATE_CREDENTIAL_REQUEST';
export const CREATE_CREDENTIAL_SUCCESS = 'CREATE_CREDENTIAL_SUCCESS';
export const CREATE_CREDENTIAL_FAILURE = 'CREATE_CREDENTIAL_FAILURE';

export const FETCH_CREDENTIAL_REQUEST = 'FETCH_CREDENTIAL_REQUEST';
export const FETCH_CREDENTIAL_SUCCESS = 'FETCH_CREDENTIAL_SUCCESS';
export const FETCH_CREDENTIAL_FAILURE = 'FETCH_CREDENTIAL_FAILURE';

export const DELETE_CREDENTIAL_REQUEST = 'DELETE_CREDENTIAL_REQUEST';
export const DELETE_CREDENTIAL_SUCCESS = 'DELETE_CREDENTIAL_SUCCESS';
export const DELETE_CREDENTIAL_FAILURE = 'DELETE_CREDENTIAL_FAILURE';

export const FETCH_EXTERNAL_SOURCE_LIST_REQUEST = 'FETCH_EXTERNAL_SOURCE_LIST_REQUEST';
export const FETCH_EXTERNAL_SOURCE_LIST_SUCCESS = 'FETCH_EXTERNAL_SOURCE_LIST_SUCCESS';
export const FETCH_EXTERNAL_SOURCE_LIST_FAILURE = 'FETCH_EXTERNAL_SOURCE_LIST_FAILURE';

const baseURL = 'config/api-client-tokens';
const externalSourceURL = 'config/external-sources';

export const createCredential = (credentialRequest: ICredentialRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: credentialRequest,
    authenticated: true,
    types: [CREATE_CREDENTIAL_REQUEST, CREATE_CREDENTIAL_SUCCESS, CREATE_CREDENTIAL_FAILURE],
  },
});

export const fetchCredentialList = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_CREDENTIAL_LIST_REQUEST, FETCH_CREDENTIAL_LIST_SUCCESS, FETCH_CREDENTIAL_LIST_FAILURE],
  },
});

export const fetchCredentialById = (credentialId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${credentialId}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_CREDENTIAL_REQUEST, FETCH_CREDENTIAL_SUCCESS, FETCH_CREDENTIAL_FAILURE],
  },
});

export const deleteCredential = (credentialId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${credentialId}`,
    method: 'delete',
    authenticated: true,
    types: [DELETE_CREDENTIAL_REQUEST, DELETE_CREDENTIAL_SUCCESS, DELETE_CREDENTIAL_FAILURE],
  },
});

export const fetchExternalSourceList = () => ({
  [CALL_API]: {
    endpoint: externalSourceURL,
    method: 'get',
    authenticated: true,
    types: [
      FETCH_EXTERNAL_SOURCE_LIST_REQUEST,
      FETCH_EXTERNAL_SOURCE_LIST_SUCCESS,
      FETCH_EXTERNAL_SOURCE_LIST_FAILURE,
    ],
  },
});
